import { useContext } from 'react';
import { Breadcrumb, BreadcrumbsActionTypes, BreadcrumbsContext } from 'src/context/breadcrumbsContextProvider';

export const useBreadcrumbs = () => {
  const {
    state: { stack },
    dispatch
  } = useContext(BreadcrumbsContext);

  const addBreadcrumb = (newBreadcrumb: Breadcrumb) => {
    dispatch({
      type: BreadcrumbsActionTypes.ADD_TO_STACK,
      payload: newBreadcrumb
    });
  };

  const addBreadcrumbIfAbsent = (newBreadcrumb: Breadcrumb) => {
    dispatch({
      type: BreadcrumbsActionTypes.ADD_TO_STACK_IF_ABSENT,
      payload: newBreadcrumb
    });
  };

  const addMultipleBreadcrumbs = (newBreadcrumbArray: Breadcrumb[]) => {
    dispatch({
      type: BreadcrumbsActionTypes.ADD_MULTIPLE_TO_STACK,
      payload: newBreadcrumbArray
    });
  };

  const overwriteBreadcrumbs = (newBreadcrumbArray: Breadcrumb[]) => {
    dispatch({
      type: BreadcrumbsActionTypes.OVERWRITE_BREADCRUMBS,
      payload: newBreadcrumbArray
    });
  };

  const replacePathBreadcrumbs = (pathBreadcrumbs: Breadcrumb[]) => {
    dispatch({
      type: BreadcrumbsActionTypes.REPLACE_PATH_BREADCRUMBS,
      payload: pathBreadcrumbs
    });
  };

  const removeLastBreadcrumb = () => {
    dispatch({
      type: BreadcrumbsActionTypes.POP_FROM_STACK
    });
  };

  const removeBreadcrumbByTitle = (title: string) => {
    dispatch({
      type: BreadcrumbsActionTypes.REMOVE_BREADCRUMB_BY_TITLE,
      payload: title
    });
  };

  const renameBreadcrumbByTitle = (title: string, newTitle: string) => {
    dispatch({
      type: BreadcrumbsActionTypes.RENAME_BREADCRUMB_BY_TITLE,
      payload: { oldTitle: title, newTitle }
    });
  };

  const editLastBreadcrumb = (newBreadcrumb: Breadcrumb) => {
    const stackCopy = [...stack];
    stackCopy[stackCopy.length - 1] = newBreadcrumb;

    dispatch({
      type: BreadcrumbsActionTypes.OVERWRITE_BREADCRUMBS,
      payload: stackCopy
    });
  };

  return {
    breadcrumbs: stack,
    addBreadcrumb,
    addBreadcrumbIfAbsent,
    addMultipleBreadcrumbs,
    overwriteBreadcrumbs,
    replacePathBreadcrumbs,
    removeLastBreadcrumb,
    removeBreadcrumbByTitle,
    renameBreadcrumbByTitle,
    editLastBreadcrumb
  };
};
